<template>
  <a-modal
    :closable="false"
    @cancel="handleClose"
    :visible="visible"
    title=""
    :footer="false"
  >
    <div class="content_">
      <a-row>
        <a-col :span="11">
          <img src="~@/assets/medilinkPC/cashier/2.png" class="img_" />
          <div class="title_">{{ $t("cashierDesk[29]") || "卡有效期" }}</div>
          <div class="desc_">
            {{ $t("cashierDesk[32]") || "格式为：月/年 " }}<br />{{
              $t("cashierDesk[43]") || "信用卡有效期通常在卡正面"
            }}
          </div>
        </a-col>
        <a-col style="margin-left: 36px;" offset="2" :span="11">
          <img src="~@/assets/medilinkPC/cashier/1.png" class="img_" />
          <div class="title_">{{ $t("cashierDesk[30]") || "卡验证码" }}</div>
          <div class="desc_">
            {{
              $t("cashierDesk[44]") ||
                "也称信用安全码，或CVV2，是指信用卡背面签名栏上跟在卡号末尾的3或4位数字，位置如上图，个别卡片位置有所不同。"
            }}
          </div>
        </a-col>
      </a-row>
      <div>
        <a-button @click="handleClose" class="btn_" type="primary">{{
          $t("cashierDesk[42]") || "我知道了"
        }}</a-button>
      </div>
    </div>
  </a-modal>
</template>
<style lang="scss" scoped>
.content_ {
  padding-top: 20px;
  .btn_ {
    margin-top: 26px;
  }
}
.img_ {
  width: 223px;
  height: 135px;
  margin-bottom: 10px;
}
.title_ {
  font-size: 14px;
  font-family: MicrosoftYaHeiUISemibold;
  color: #394155;
  text-align: center;
  font-weight: 600;
}
.desc_ {
  font-size: 12px;
  font-family: MicrosoftYaHeiUI;
  color: #394155;
}
.btn_ {
  width: 170px;
  height: 40px;
  border-radius: 2px;
  display: block;
  margin: 0 auto;
}
</style>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    }
  },
  methods: {
    handleClose() {
      this.$emit("cancel");
    }
  }
};
</script>
